<template>
  <div class="ibox-content" @click.self="open = false">
    <b-tabs v-model="tabIndex">
      <b-tab v-if="!isLiteMode" :title="$t('topTitle')">
        <div class="panel-body user-itembox" v-if="tabIndex == 0">
          <section>
            <div v-for="(obj, index) in getObjectivesByUser" :key="obj.id" v-if="obj.objective.contentText" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index">
              <div @click="onClickObjective(obj.objective, obj.key)"  class="ibox-title cursor" v-bind:class="{ isForceBrowsing: !!obj.objective.isForceBrowed }">
                <objective :detailView="false" :content="obj.objective.contentText" :progress="obj.objective.progress ? '' + obj.objective.progress : '0'" :setReadOnly="'false'" :objective="true"/>
                <div class="ibox-tools">
                  <span @click.stop="setKeyresultOpen(obj.key)" class="info-menu cursor">
                    <a class="collapse-link">
                      <i :class="{'chevronUp' : !getIsOpen(obj.key)}" class="fa fa-chevron-down"></i>
                    </a>
                  </span>
                  <span class="info-right">
                    <span class="info-comment-detail" v-if="obj.objective.hasOwnProperty('sharedOwners') && Object.keys(obj.objective['sharedOwners']).length > 0">
                      <img :src="'static/img/assets/nav_people_on.png'">
                    </span>
                    <span class="info-comment-detail">
                      <img src="static/img/assets/comment.png">
                      <span>{{getCommentsByCommentIdsTargetType(obj.objective.comments || {}, 'objectives').length}}</span>
                    </span>
                    <span class="info-comment-detail">
                      <img src="static/img/assets/relation_object_list.png">
                      <span>{{ obj.objective.relations ? Object.keys(obj.objective.relations).length : 0 }}</span>
                    </span>
                    <div class="info-comment-right">
                      <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                      <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                    </div>
                    <button @click="onClickDeleteItem('objectives', getTargetUserId, obj.key, 'contentText')" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button>
                  </span>
                </div>
              </div>
              <div :class="{'keyResultClose' : getIsOpen(obj.key)}" class="ibox-content key-indent">
              <!-- ボックス -->
                <!-- KeyResult1 -->
                <div @click="onClickKeyresult(keyresult, key)" v-for="(keyresult, key) in getOtherUserTargetKeyresults(userId, obj.objective.keyresults)" :key="key" v-if="keyresult.contentText" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult), 'isForceBrowsing' : keyresult.isForceBrowed}">
                  <div>
                    <span class="comp"></span>
                    <objective :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? '' + keyresult.progress : '0'" :setReadOnly="'false'" :objective="false"/>
                  </div>
                  <div class="ibox-tools">
                    <span class="info-menu"></span>
                    <span class="info-right">
                      <span class="info-comment-detail" v-if="keyresult.hasOwnProperty('sharedOwners') && Object.keys(keyresult['sharedOwners']).length > 0">
                        <img :src="'static/img/assets/nav_people_on.png'">
                      </span>
                      <span class="info-comment-detail">
                        <img src="static/img/assets/comment.png"><span>{{getCommentsByCommentIdsTargetType(keyresult.comments || {},'keyresults').length}}</span>
                      </span>
                      <span class="info-comment-detail">
                        <img src="static/img/assets/relation_object_list.png">
                        <span>{{ keyresult.relations ? Object.keys(keyresult.relations).length : 0 }}</span>
                      </span>
                      <div class="info-comment-right">
                        <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                        <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                      </div>
                      <button @click="onClickDeleteItem('keyresults', getTargetUserId, key, 'contentText')" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button>
                    </span>
                  </div>
                </div>
                <!-- /KeyResult1  -->
              <!-- /ボックス -->
              </div>
            </div>
          </section>
        </div>
      </b-tab>
      <b-tab :title="$t('oneOnTileType')">
        <div class="panel-body user-itembox" v-if="(tabIndex == 0 && isLiteMode) || (tabIndex == 1 && !isLiteMode)">
          <section>
            <!-- 1on1item -->
            <div v-for="(oneItem, index) in get1on1sByUser" :key="oneItem.one.id" v-if="oneItem.one.contents" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index" v-bind:class="{ isForceBrowsing: !!oneItem.one.isForceBrowed }">
              <div class="ibox-title">
                <div class="flex-box fl-between">
                  <h3 class="h3">{{$t('retrospectiveStr').replace('{$date}', oneItem.one.date)}}</h3>
                </div>
              </div>
              <div class="ibox-content">
                <!-- 1on1Component2 -->
                <div @click="onClickOneItem(oneItem.one, oneItem.key , 0)" id="one-item2" class="ibox-child one-child cursor">
                  <div class="flex-box cursor">
                    <img class="one-icon" src="static/img/1on1/img01.png" alt="">
                    <div class="comment">
                      <h4 class="h4">{{$t('firstContent1on1')}}</h4>
                      <one-item :detailView="false" :item="oneItem.one.contents[0]"/>
                      <div class="ibox-tools">
                        <span class="info-menu">
                          <span class="info-comment" >
                            <img src="static/img/assets/comment.png">
                            <span>{{ getCommentsByCommentIdsTargetType(oneItem.one.comments || {},'1on1s_0').length }}</span>
                          </span>
                          <a class="info-comment-detail" href="#">
                            <img class="star" v-if="isOneLiked(oneItem.one.likes,0)":src="'static/img/assets/nice_on.png'">
                            <img class="star" v-else :src="'static/img/assets/nice_off.png'">
                            <span class="like-counter" ><strong>{{ isLikeExist(oneItem.one, 0) ? Object.keys(oneItem.one.likes[0]).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                          </a>
                        </span>
                        <span class="info-right">
                          <button @click="onClickDeleteItem('1on1s', getTargetUserId, oneItem.key, 0)" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /1on1Component2  -->
                <!-- 1on1Component3 -->
                <div @click="onClickOneItem(oneItem.one, oneItem.key, 1)" id="one-item3" class="ibox-child one-child cursor">
                  <div class="flex-box cursor">
                    <img class="one-icon" src="static/img/1on1/img02.png" alt="">
                    <div class="comment">
                      <h4 class="h4">{{$t('secondContent1on1')}}</h4>
                      <one-item :detailView="false" :item="oneItem.one.contents[1]"/>
                      <div class="ibox-tools">
                        <span class="info-menu">
                          <span class="info-comment" >
                            <img src="static/img/assets/comment.png">
                            <span>{{ getCommentsByCommentIdsTargetType(oneItem.one.comments || {},'1on1s_1').length }}</span>
                          </span>
                          <a class="info-comment-detail" href="#">
                            <img class="star" v-if="isOneLiked(oneItem.one.likes,1)":src="'static/img/assets/nice_on.png'">
                            <img class="star" v-else :src="'static/img/assets/nice_off.png'">
                            <span class="like-counter"><strong>{{ isLikeExist(oneItem.one, 1) ? Object.keys(oneItem.one.likes[1]).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                          </a>
                        </span>
                        <span class="info-right">
                          <button @click="onClickDeleteItem('1on1s', getTargetUserId, oneItem.key, 1)" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /1on1Component3  -->
                <!-- 1on1Component4 -->
                <div @click="onClickOneItem(oneItem.one, oneItem.key,  2)" id="one-item4" class="ibox-child one-child cursor">
                  <div class="flex-box cursor">
                    <img class="one-icon" src="static/img/1on1/img03.png" alt="">
                    <div class="comment">
                      <h4 class="h4">{{$t('thirdContent1on1')}}</h4>
                      <one-item :detailView="false" :item="oneItem.one.contents[2]"/>
                      <div class="ibox-tools">
                        <span class="info-menu">
                          <span class="info-comment" href="#">
                            <img src="static/img/assets/comment.png">
                            <span>{{ getCommentsByCommentIdsTargetType(oneItem.one.comments || {},'1on1s_2').length }}</span>
                          </span>
                          <a class="info-comment-detail" href="#">
                            <img class="star" v-if="isOneLiked(oneItem.one.likes,2)":src="'static/img/assets/nice_on.png'">
                            <img class="star" v-else :src="'static/img/assets/nice_off.png'">
                            <span class="like-counter"><strong>{{ isLikeExist(oneItem.one, 2) ? Object.keys(oneItem.one.likes[2]).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                          </a>
                        </span>
                        <span class="info-right">
                          <button @click="onClickDeleteItem('1on1s', getTargetUserId, oneItem.key, 2)" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /1on1Component4  -->
              </div>
              <!-- /ibox-content -->
            </div>
            <!-- /1on1item -->
          </section>
        </div>
      </b-tab>
      <b-tab :title="$t('rtfbType')">
        <div class="panel-body user-itembox"  v-if="(tabIndex == 1 && isLiteMode) || (tabIndex == 2 && !isLiteMode)">
          <div class="ibox" style="overflow: hidden" >
            <div class="ibox-child"  v-for="(feed, index) in getRtfbsByUser" :key="feed.id" v-if="Object.values(getRtfbs)[0] && feed.feed && feed.feed.contentText" :accessKey="index" v-observe-visibility="visibilityChanged"v-bind:class="{ isForceBrowsing: !!feed.isForceBrowed }">
              <div @click="onClickRequest(feed.feed, feed.key)" class="flex-box cursor">
                <span class="info-userimg">
                  <img v-if="getUsers[feed.feed.userId].userInfo.userIcon" alt="image" class="img-circle" :src="getUsers[feed.feed.userId].userInfo.userIcon">
                  <img v-else alt="image" class="img-circle" :src="'static/img/noImage.png'">
                </span>
                <div class="comment d-flex flex-column mb-2">
                  <fb-item :detailView="false" :item="feed.feed" :itemId="feed.key"/>
                  <div class="child-tools">
                    <span class="info-menu">
                      <span class="info-comment">
                        <img src="static/img/assets/comment.png">
                        <span>{{ getCommentsByCommentIdsTargetType(feed.feed.comments || {},'rtfbs').length }}</span>
                      </span>
                      <a class="info-comment">
                        <img v-if="isLiked(feed.feed)" src="static/img/assets/nice_on.png">
                        <img v-else src="static/img/assets/nice_off.png">
                        <span class="like-counter" v-if="feed.feed.likes"><strong>{{ feed.feed.likes ? Object.keys(feed.feed.likes).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                      </a>
                    </span>
                    <span class="info-right">
                      <button @click="onClickDeleteItem('rtfbs', getTargetUserId, feed.key, 'contentText')" type="button" class="btn btn-danger block m-b pull-right">{{ $t('deleteStr') }}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('commentLabelTitle')">
        <div class="panel-body user-itembox" v-if="(tabIndex == 2 && isLiteMode) || (tabIndex == 3 && !isLiteMode)">
          <div class="ibox">
            <!-- <div class="ibox-child"  v-for="(comment, index) in getCommentsByUser" :key="comment.id" v-if="getCommentsByUser[0] && comment.comment && comment.comment.contentText" v-observe-visibility="visibilityChanged" :accessKey="index"> -->
            <div class="ibox-child"  v-for="(comment, index) in getCommentsByUser" :key="comment.id" v-if="isVisibleComment(comment)" v-observe-visibility="visibilityChanged" :accessKey="index">
              <div @click="onClickComment(comment.comment, comment.key)" class="cursor">
                <div class="flex-box fl-between">
                  <div class="flex-box">
                    <div v-if="comment.comment.targetOwner" class="target-item flex-box">
                      <label>{{$t('replyTargetLabel')}}</label>
                      <span v-html="getCommentReplyTarget(comment.comment.targetOwner, comment.comment.target)" class="user-name"></span>
                    </div>
                  </div>
                </div>
                <div class="comment d-flex flex-column">
                  <comment-item :propComment="comment.comment" :isShowChild="false" :isManage="true" :isDetail="false"/>
                  <div class="w-100 pull-right">
                    <button @click="onClickDeleteItem('comments', getTargetUserId, comment.key, 'contentText')" type="button" class="btn btn-danger block m-b pull-right mt-4" v-if="!comment.comment.isDelete">{{ $t('deleteStr') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import CommonJs from '@/js/common'
import Objective from '@/components/Okr/Objective'
import OkrDropDown from '@/components/Okr/OkrDropDown'
import SelectDropDown from '@/components/Okr/SelectDropDown'
import RelationItem from '@/components/Okr/RelationItem'
import OneDropDown from '@/components/One/OneDropDown'
import OneItem from '@/components/One/OneItem'
import FbItem from '@/components/Fb/FbItem'
import FbDropDown from '@/components/Fb/FbDropDown'
// import CommentItem from '@/components/Comment/CommentItem'
import CommentItem from '@/components/Comment/CommentItemInManage'
import CommentForm from '@/components/Comment/CommentForm'
import moment from 'moment'
import CommentDropDown from '@/components/Comment/CommentDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import { liteMode } from '@/main'

export default {
  name: 'ManageOtherItems',
  mixins: [CommonJs],
  components: {
    Objective,
    OkrDropDown,
    SelectDropDown,
    RelationItem,
    OneDropDown,
    OneItem,
    FbItem,
    FbDropDown,
    CommentItem,
    CommentForm,
    CommentDropDown,
    ReadMore
  },
  props: {
    userId: String
  },
  // store,
  data: function () {
    return {
      tag: 'progress',
      isLiteMode: liteMode,
      user: [],
      open: false,
      tabIndex: 0,
      propShowMore: false,
      propContentHeight: 0,
      showCount: [10, 10, 10, 10, 10],
      count: 10,
      imageSrc: {
        objectives: 'static/img/assets/nav_okr_on.png',
        keyresults: 'static/img/assets/nav_okr_on.png',
        '1on1s_': 'static/img/assets/nav_1on1_on.png',
        rtfbs: 'static/img/assets/nav_rtfb_on.png'
      },
      // OKR
      objectiveId: '',
      objectives: [],
      // targetType: 'objectives',
      targetItem: {
        progress: '0',
        contentText: '',
        createdAt: '',
        dueDate: '',
        limitedAccess: {},
        relations: {}
      },
      targetType: '',
      targetItemProgress: 0,
      targetItemKey: '',
      targetKeyresults: {},
      comp: true,
      orderType: {
        key: '',
        isDesc: true
      },
      keyresultOpen: {},
      // 1on1
      targetOneItem: {},
      targetOneItemKey: '',
      // feedback
      feedItems: {},
      detail: {},
      targetFeed: {},
      targetFeedKey: '',
      // targetType: 'rtfbs',
      targetUserId: '',
      targetUserName: '',
      targetUserIcon: '',
      targetContent: '',
      targetLikes: {},
      target1on1Request: {},
      target1on1RequestKey: '',
      // key: '',
      targetComment: {},
      targetCommentKey: '',
      replyParent: {}
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('rtfbs/', [
      'getRtfbs',
      'getRtfbsByUserId',
      'getRtfbById'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsAdmin',
      'getMetaIsForceBrowsing'
    ]),
    ...mapGetters('ones/', [
      'get1on1s',
      'get1on1ById',
      'getCurrent1on1s',
      'get1on1sByUserId',
      'get1on1RequestsByUserId'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultById',
      'getCurrentKeyresults',
      'getOtherUserKeyresultsByIds'
    ]),
    ...mapGetters('objectives', [
      'getObjectivesByUserId',
      'getObjectiveById',
      'getCurrentObjectives',
      'getObjectives'
    ]),
    ...mapGetters('comments/', [
      'getComments',
      'getCommentsByItemId',
      'getCommentsByUserId',
      'getChildCommentsByParentId',
      'getCommentsByCommentIdsTargetType'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUserInfoById'
    ]),
    ...mapGetters('users/', [
      'getUsers'
    ]),
    isForceBrowsing () {
      return this.getMetaIsForceBrowsing
    },
    sendOneOnRequestMsgString () { return this.$t('sendOneOnRequestMsgString') },
    getReplyTargetMessage () { return this.$t('replyTargetMessage') },
    getTargetUserId () { return this.userId },
    getObjectivesByUser: function () {
      const currentObjectives = this.getObjectivesByUserId(this.userId, true, this.isForceBrowsing)
      console.log(this.userId)
      let incompletedObjectives = []
      for (const key in currentObjectives) {
        if (!currentObjectives[key].isComplete) {
          incompletedObjectives.push({key: key, objective: currentObjectives[key]})
        } else if (currentObjectives[key].isComplete === false) {
          incompletedObjectives.push({key: key, objective: currentObjectives[key]})
        }
      }
      return incompletedObjectives.reverse().slice(0, this.showCount[0])
      // return incompletedObjectives
    },
    get1on1sByUser: function () {
      let get1on1s = this.get1on1sByUserId(this.userId, true, this.isForceBrowsing)
      let ones = []
      for (let keys in get1on1s) {
        // console.log(get1on1s[keys].date)
        if (get1on1s[keys] && get1on1s[keys].contents) {
          // console.log('get1on1s[oneKey]::::', get1on1s[keys])
          get1on1s[keys].date = get1on1s[keys].date.replace(/-/g, '/')
          ones.push({
            key: keys,
            one: get1on1s[keys]
          })
        }
      }
      return ones.reverse().slice(0, this.showCount[1])
    },
    getRtfbsByUser: function () {
      return this.getRtfbsByUserId(this.userId, this.getUserId, true).reverse().slice(0, this.showCount[2])
    },
    getCommentsByUser: function () {
      return this.getCommentsByUserId(this.userId, true).reverse().slice(0, this.showCount[3])
    },
    get1on1RequestsByUser: function () {
      let requests = []
      const onereqs = this.get1on1RequestsByUserId(this.userId, true).send1on1
      for (let key in onereqs) {
        requests.push({
          key: key,
          onereq: onereqs[key]
        })
      }
      return requests.reverse()
    },
    getTargetLimitedAccess () {
      if (!this.targetItem.limitedAccess) {
        return {}
      } else if (this.targetItem.limitedAccess.limitedUsers) {
        return this.getUsersByIds(Object.keys(this.targetItem.limitedAccess.limitedUsers))
        // return !this.targetItem.limitedAccess.limitedGroup ? this.getUsersByIds(this.targetItem.limitedAccess.limitedUsers.keys) : this.targetItem.limitedAccess.limitedGroup
      } else if (this.targetItem.limitedAccess.limitedGroup) {
        return this.targetItem.limitedAccess.limitedGroup
      }
    },
    getRelationLength () {
      return this.targetItem.relations ? Object.keys(this.targetItem.relations).length : 0
    },
    getTargetOkrComments () {
      return this.getCommentsByCommentIdsTargetType(this.targetItem.comments || {}, this.targetType)
    },
    getTargetOneItemComments () {
      return this.getCommentsByCommentIdsTargetType(this.targetOneItem.comments || {}, this.targetType)
    },
    getTargetFbComments () {
      return this.getCommentsByCommentIdsTargetType(this.targetFeed.comments || {}, this.targetType)
    }
  },
  watch: {
    tabIndex: function (value) {
      for (const i in this.showCount) {
        this.$set(this.showCount, i, i === value ? this.showCount[i] : this.count)
      }
    }
  },
  methods: {
    ...mapActions('comments/', {
      removeComment: 'REMOVE_COMMENT'
    }),
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.showCount[this.tabIndex] - 1) {
        this.$set(this.showCount, this.tabIndex, this.showCount[this.tabIndex] + 20)
        console.log('visibilityChanged: ', this.showCount)
      }
    },
    // ここから、他人のアイテム表示用の関数
    onClickObjective: function (obj, key) {
      this.targetItem = obj
      this.targetItemKey = key
      this.targetType = 'objectives'
      this.targetItemProgress = this.targetItem.progress
      this.targetItem.progress = this.targetItem.progress ? this.targetItem.progress : '0'
      this.updateTarget()
    },
    onClickParent: function (comment) {
      this.$router.push({ name: 'User', params: { userId: comment.targetOwner, type: comment.target, itemId: comment.targetId } })
    },
    onClickKeyresult: function (obj, key) {
      this.targetItem = obj
      this.targetItemKey = key
      this.targetType = 'keyresults'
      this.targetItemProgress = this.targetItem.progress
      this.targetItem.progress = this.targetItem.progress ? this.targetItem.progress : '0'
      this.updateTarget()
    },
    getParentTarget: function (type, key, userId) {
      const oneRegExp = new RegExp('1on1s_', 'gi')
      if (oneRegExp.test(type)) {
        return this.get1on1ById(userId, key, true) ? this.get1on1ById(userId, key, true) : {}
      }
      switch (type) {
        case 'objectives':
          return this.getObjectiveById(key, userId, true) ? this.getObjectiveById(key, userId, true) : {}
        case 'keyresults':
          return this.getKeyresultById(key, userId, true) ? this.getKeyresultById(key, userId, true) : {}
        case 'rtfbs':
          return this.getRtfbById(key, true) ? this.getRtfbById(key, true) : {}
          // return this.getRtfbById(userId, key, true) ? this.getRtfbById(userId, key, true) : {}
        default:
          break
      }
      return {}
    },
    updateTarget: function (commentId = '') {
      let value
      console.log('updatetarget')
      if (this.targetType === 'objectives' || this.targetType === 'keyresults') {
        console.log('updateTarget in objective')
        value = {
          targetType: this.targetType,
          targetItem: this.targetItem,
          targetItemKey: this.targetItemKey
        }
      } else if (this.targetType.match(/1on1s_/)) {
        console.log('updateTarget in 1on1')
        value = {
          targetLikes: this.targetOneItem['likes'][this.targetContent],
          targetOneItem: this.targetOneItem,
          targetOneItemKey: this.targetOneItemKey,
          targetContent: this.targetContent,
          targetType: this.targetType
        }
      } else if (this.targetType === 'rtfbs') {
        console.log('updateTarget in rtfbs')
        value = {
          targetFeed: this.targetFeed,
          targetFeedKey: this.targetFeedKey,
          targetUserName: this.targetUserName,
          targetUserIcon: this.targetUserIcon,
          targetType: this.targetType,
          targetUserId: this.targetUserId
        }
        console.log(this.targetFeed)
        // this.open = true
      } else if (this.targetType === 'comments') {
        value = {
          targetType: this.targetType,
          targetComment: this.targetComment,
          targetCommentKey: this.targetCommentKey
        }
      } else if (this.targetType === '1on1requests') {
        value = {
          targetType: this.targetType,
          target1on1Request: this.target1on1Request,
          target1on1RequestKey: this.target1on1RequestKey
        }
      }
      console.log('ta-gettocomment', this.targetComment)
      if (commentId.length > 0) {
        value.targetOwner = this.targetComment.targetOwner
      }
      value.commentId = commentId
      console.log('updatetarget', value)
      this.$emit('set-target', value)
    },
    setKeyresultOpen: function (objectiveId) {
      Vue.set(this.keyresultOpen, objectiveId, Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.keyresultOpen[objectiveId])
    },
    getIsOpen: function (objectiveId) {
      return Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId]
    },
    getOtherUserTargetKeyresults (userId, keyresultsObject) {
      // 算出プロパティだと引数がつけられないためmethodに
      return keyresultsObject ? this.getOtherUserKeyresultsByIds(userId, Object.keys(keyresultsObject), true, this.isForceBrowsing) : {}
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete === 1
    },
    getRequestsByNoticeType (sentItem) {
      let contentText
      if (this.getUsers) {
        contentText = this.sendOneOnRequestMsgString.replace('{$user}', this.getUsers[sentItem.userId].userInfo.userName)
      } else {
        contentText = sentItem.userName + this.sendOneOnRequestMsgString
      }
      return contentText
    },
    onClickOneItem: function (oneItem, key, content) {
      this.targetOneItem = !oneItem ? [] : oneItem
      this.targetOneItemKey = key
      this.targetContent = content
      this.targetType = '1on1s_' + content
      this.updateTarget()
    },
    onClickComment: function (comment, key) {
      this.targetComment = comment
      this.targetCommentKey = key
      console.log('update', comment)
      this.targetType = comment.target
      const target = this.getParentTarget(comment.target, comment.targetId, comment.targetOwner)
      const targetKey = comment.targetId
      if (this.targetType.match(/1on1s_/)) {
        this.targetOneItem = target
        this.targetOneItemKey = targetKey
        this.targetContent = this.targetType.split('_')[1]
      }
      switch (this.targetType) {
        case 'objectives':
        case 'keyresults':
          this.targetItem = target
          this.targetItemKey = targetKey
          break
        case 'rtfbs':
          this.targetFeed = target
          this.targetFeedKey = targetKey
          console.log(comment.targetOwner)
          const gotUser = comment.targetOwner ? this.getUserInfoById(comment.targetOwner) : {}
          this.targetUserIcon = gotUser.userIcon ? gotUser.userIcon : ''
          this.targetUserName = gotUser.userName ? gotUser.userName : ''
          this.targetUserId = comment.targetOwner ? comment.targetOwner : ''
      }
      this.updateTarget(key)
    },
    onClickRequest: function (feed, key) {
      console.log('onclick Request')
      this.targetFeed = !feed ? [] : feed
      console.log(this.targetFeed.contentText)
      this.targetFeedKey = key
      this.targetUserId = feed.userId
      this.targetType = 'rtfbs'
      this.targetUserName = this.getUsers[feed.userId].userInfo.userName
      this.targetUserIcon = this.getUsers[feed.userId].userInfo.userIcon
      this.updateTarget()
    },
    onclick1on1Request: function (rq, key) {
      this.target1on1Request = !rq ? {} : rq
      this.target1on1RequestKey = key
      this.targetType = '1on1requests'
      this.updateTarget()
    },
    isLiked: function (feed) {
      if (!feed.likes) {
        return false
      } else {
        return Object.keys(feed.likes).filter(x => x === this.getUserId).length !== 0
      }
    },
    isOneLiked: function (likes, number) {
      if (!likes || !likes.hasOwnProperty(number)) {
        return false
      } else {
        return Object.keys(likes[number]).filter(x => x === this.getUserId).length !== 0
      }
    },
    onOneClickStarNotLiked: function (key, number) {
      this.setOneLikes({
        key: key,
        userId: this.getUserId,
        contentKey: number,
        targetUserId: this.getUserId
      })
    },
    onOneClickStarLiked: function (key, number) {
      this.removeOneLikes({
        key: key,
        userId: this.getUserId,
        contentKey: number,
        targetUserId: this.getUserId
      })
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    onClickDeleteItem (targetType, userId, itemId, content) {
      this.$swal({
        title: this.$t('doDeleteStr'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false
      }).then((result) => {
        if (result.value) {
          if (targetType === 'comments') {
            console.log('ManageOtherItems:onClickDeleteItem')
            this.commentDelete(this.getComments[itemId]).then(
              this.$swal({
                title: this.$t('compDeleteStr'),
                type: 'success'
              })
            )
          } else {
            this.sendDeleteRequest(targetType, userId, itemId, content).then(
              this.$swal({
                title: this.$t('compDeleteStr'),
                type: 'success'
              })
            )
          }
        } else {
          console.log('confirmDeletePictureStr -> false')
        }
      })
    },
    sendDeleteRequest: function (type, userId, itemId, content) {
      const censorText = this.$firebase.functions().httpsCallable('censorText')
      console.log('type, userId, itemId, content', type, userId, itemId, content)
      return censorText({
        type: type,
        userId: userId,
        itemId: itemId,
        content: content
      }).then(res => {
        console.log('deleteResponse: ', res)
      }).catch(err => {
        console.log('deleteResponseError: ', err)
      })
    },
    commentDelete: async function (comment) {
      let deleteInfo = {}
      if (this.getChildCommentsByParentId(comment.id, comment.target).length > 0) {
        deleteInfo = {
          parentId: 'parent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          targetOwner: comment.targetOwner,
          userId: comment.userId
        }
      } else if (comment.parentId) {
        deleteInfo = {
          parentId: comment.parentId,
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          targetOwner: comment.targetOwner,
          userId: comment.userId
        }
      } else {
        deleteInfo = {
          parentId: 'notParent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          targetOwner: comment.targetOwner,
          userId: comment.userId
        }
      }
      if (comment.uploadedFile) {
        console.log('deleteInfo add deleteimage')
        deleteInfo.uploadedFile = comment.uploadedFile
      }
      deleteInfo.byManager = true
      console.log('ManageOtherItems:commentDelete', deleteInfo)
      this.removeComment(deleteInfo)
    },
    getCommentReplyTarget (ownerId, target) {
      let $t = this.$t
      let contentText
      let str
      let icon
      // console.log(target)
      switch (target) {
        case 'objectives' :
          str = $t('okrDetailType')
          icon = '<img src="static/img/assets/nav_okr_on.png" class="info-icon">'
          break
        case 'keyresults' :
          str = $t('keyResultDetailType')
          icon = '<img src="static/img/assets/nav_okr_on.png" class="info-icon">'
          break
        case '1on1s_0' :
          str = $t('firstContent1on1')
          icon = '<img src="static/img/assets/nav_1on1_on.png" class="info-icon">'
          break
        case '1on1s_1' :
          str = $t('secondContent1on1')
          icon = '<img src="static/img/assets/nav_1on1_on.png" class="info-icon">'
          break
        case '1on1s_2' :
          str = $t('fourContent1on1')
          icon = '<img src="static/img/assets/nav_1on1_on.png" class="info-icon">'
          break
        case '1on1s_3' :
          str = $t('forthContent1on1')
          icon = '<img src="static/img/assets/nav_1on1_on.png" class="info-icon">'
          break
        case 'rtfbs' :
          str = $t('rtfbType')
          icon = '<img src="static/img/assets/nav_rtfb_on.png" class="info-icon">'
          break
      }
      contentText = icon + this.getReplyTargetMessage.replace('{$user}', this.getUsers[ownerId].userInfo.userName).replace('{$target}', str)
      // console.log('str:::', str)
      // console.log(contentText.replace('{$target}', str))
      // contentText.replace('{$target}', str)
      // console.log('contentText:::', contentText)
      // if (target === 'objectives') contentText.replace('{$target}', $t('okrDetailType'))
      // else if (target === 'keyresults') contentText.replace('{$target}', $t('keyResultDetailType'))
      // else if (target === '1on1') contentText.replace('{$target}', $t('keyResultDetailType'))
      return contentText
    },
    isVisibleComment: function (c) {
      // console.log('isVisibleComment:', c)
      if (!c.key || !c.comment || !c.comment.contentText) {
        console.log('isVisibleComment: invalid comment.')
        return false
      }
      // console.log('isVisibleComment:', c.comment.contentText)
      if (!c.comment.target || !c.comment.targetId || !c.comment.targetOwner) {
        console.log('isVisibleComment: invalid target.')
        return false
      }
      let target
      let commentTarget = c.comment.target.split('_')[0]
      switch (commentTarget) {
        case 'objectives':
          target = this.getObjectiveById(c.comment.targetId, c.comment.targetOwner, true)
          break
        case 'keyresults':
          target = this.getKeyresultById(c.comment.targetId, c.comment.targetOwner, true)
          break
        case '1on1s':
          target = this.get1on1ById(c.comment.targetOwner, c.comment.targetId, true)
          break
        case 'rtfbs':
          target = this.getRtfbById(c.comment.targetId, true)
          break
        default:
          console.log('isVisibleComment: Unknow type')
          return false
      }
      if (this.isLiteMode && (commentTarget === 'objectives' || commentTarget === 'keyresults')) {
        return false
      }
      // console.log('isVilibleComment: target', target)
      if (!target || !Object.keys(target).length) {
        console.log('isVisibleComment: target is not exist.')
        return false
      }
      return true
    },
    isLikeExist (oneItem, index) {
      if (!(oneItem && oneItem.likes)) {
        return !!oneItem.likes[index]
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    oneTime: function (dateString) {
      return dateString.split('-').join('/')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .user-itembox {
    padding: 0 1rem;
  }
  .isForceBrowsing {
    border: 3px solid #cc0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Manage/ManageOtherItems.vue